var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-integrations"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "integrations",
    clipPath: "url(#clip-integrations)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15837",
    "data-name": "Group 15837",
    transform: "translate(-20 -580)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "int",
    transform: "translate(18 578)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23761",
    "data-name": "Rectangle 23761",
    width: 44,
    height: 44,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18126",
    "data-name": "Path 18126",
    d: "M19.984,35.72H18.848a1.192,1.192,0,0,1-1.192-1.192V32.97a1.082,1.082,0,0,0-.788-1.027,12.136,12.136,0,0,1-3.227-1.338h0a1.082,1.082,0,0,0-1.283.165l-1.1,1.1h0a1.192,1.192,0,0,1-1.7,0L7.958,30.275h0a1.228,1.228,0,0,1,0-1.7l1.1-1.1a1.027,1.027,0,0,0,.165-1.283,12.924,12.924,0,0,1-1.338-3.208,1.027,1.027,0,0,0-1.008-.7H5.318a1.21,1.21,0,0,1-1.21-1.21V18.726a1.21,1.21,0,0,1,1.21-1.21h1.54a1.063,1.063,0,0,0,1.027-.733,12.136,12.136,0,0,1,1.338-3.227,1.063,1.063,0,0,0-.165-1.283l-1.1-1.1h0a1.173,1.173,0,0,1,0-1.687L9.553,7.891h0a1.21,1.21,0,0,1,1.7,0l1.1,1.1a1.045,1.045,0,0,0,1.283.147,12.081,12.081,0,0,1,3.227-1.32,1.082,1.082,0,0,0,.788-1.027V5.178A1.21,1.21,0,0,1,18.848,3.95h1.137V1.86H18.848a3.318,3.318,0,0,0-3.318,3.318V5.93a17.2,17.2,0,0,0-2.255.935l-.532-.532a3.3,3.3,0,0,0-4.693,0L6.455,7.928h0a3.318,3.318,0,0,0,0,4.675l.55.55a17.2,17.2,0,0,0-.935,2.255H5.318A3.318,3.318,0,0,0,2,18.726v2.255H2A3.318,3.318,0,0,0,5.318,24.3H6.07A12.173,12.173,0,0,0,7,26.554l-.55.55h0a3.318,3.318,0,0,0,0,4.675L8.05,33.374h0a3.3,3.3,0,0,0,4.693,0l.55-.55a12.173,12.173,0,0,0,2.255.935v.77a3.318,3.318,0,0,0,3.3,3.3h1.137Z",
    transform: "translate(1.667 1.55)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18127",
    "data-name": "Path 18127",
    d: "M15.368,20.948a5.72,5.72,0,1,1,0-11.44V7.4a7.828,7.828,0,1,0,0,15.656Z",
    transform: "translate(6.283 6.166)",
    fill: "#5c6d7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18128",
    "data-name": "Path 18128",
    d: "M5.016.22l-4.8,4.8A.75.75,0,0,0,1.279,6.077L4.8,2.56V15.37a.75.75,0,0,0,1.5,0V2.56L9.813,6.077a.75.75,0,0,0,1.06-1.061L6.077.22A.75.75,0,0,0,5.016.22Z",
    transform: "translate(56.117 593.582) rotate(90)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.5970c883883183b263dcb72739ff845f.svg";
export { ForwardRef as ReactComponent };